import { UuidProjectType } from 'core/userContext';
import { sentenceCase } from 'utils/stringHelpers';
export * from './defaultValues';
export * from './locales';
export * from './payload';

export const getProjectIdentifier = (isUuidBased: boolean, uuidProjectType: UuidProjectType) => {
  if (!isUuidBased) {
    return 'Email-based project (unique email)';
  }

  return uuidProjectType === UuidProjectType.EmailNonUnique
    ? 'UserID-based project (unique userId)'
    : 'Hybrid project (unique userId and unique email)';
};

export const createPositiveToastMessage = (resourceName: string, action: string) =>
  `${sentenceCase(resourceName)} was ${action} successfully. Remember to save your changes.`;
